import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-rule-block',
  templateUrl: './rule-block.component.html',
  styleUrls: ['./rule-block.component.scss']
})
export class RuleBlockComponent implements OnInit {

  @Input() index: number;
  @Input() text: string;

  rules = [
    {
      text:'У разі псування обладнання та аксесуарів Ви зобов\'язуєтесь відшкодувати збитки. Орендар зйомки несе повну матеріальну відповідальність за все обладнання та декорації студії, а також за дії осіб, які беруть участь у зйомці та/або перебувають під час зйомки у фотостудії. Якщо у Вас немає можливості на місці розплатитись, адміністратор бере в заставу Ваш паспорт чи техніку.'
    },
    {
      text:'Для оренди потрібно внести 100% оплату за орендований час протягом 24 годин з моменту бронювання.\n'
    },
    {
     text: 'Після закінчення зйомки орендар зобов\'язаний винести із зали сміття, що утворилося під час зйомки та інші предмети, що заважають подальшому проведенню зйомки в залі. Або орендар вносить оплату у розмірі 100 грн. на прибирання залу. Якщо необхідно мити підлогу - 200 грн .\n' +
       'Якщо ви хочете проводити фотозйомку з рідинами, необхідно повідомити адміністратора, забезпечити гідроізоляцію частини знімальної площі.\n' +
       '\n' +
       'Використання метофана і гліттера повинно заздалегідь обмовлятися з адміністрацією студією і здійснюється доплата у розмірі від 500 грн.'
    },
    {
      text: 'Речі, видані адміністратором, потрібно здати назад. Якщо ви щось брали, рухали у процесі своєї роботи, будь ласка, поверніть усе на місце. Адміністратору потрібно близько 5 хвилин для того, щоб перевірити справність обладнання після його використання.\n '
    },
    {
      text: 'Початком оренди студії вважається заброньований час, а не час фактичної появи орендаря у студії. При достроковому завершенні зйомки заброньований час оплачується повністю.'
    },
    {
      text: 'Якщо після заброньованого часу студія вільна, Ви можете продовжити знімальний час, сплативши додатково оренду кратно 30 хвилинам.\n'
    },
    {
      text: 'Якщо студію заброньовано до певної години - Ви зобов\'язані сплатити та залишити студію у зазначений час, без затримки, будь ласка, закінчуйте зйомку за 5-10 хвилин до кінця оренди, щоб у Вас залишився час зібратися та звільнити приміщення до наступного клієнта. Затримка більш ніж на 5 хвилин оплачується як за півгодини оренди.  \n'
    },
    {
      text: 'У разі відмови від оренди студії гроші не повертаються.\n' +
        'У разі поважної причини: ви зможете досягти зручного для студії часу зі знижкою 50% протягом 2 тижнів.'
    },
    {
      text: 'Перебувати у фотостудії можна лише у змінному взутті, важливо, щоб воно не залишало чорних рисочок на підлозі. Попереджайте про це всіх учасників зйомки. За відсутності змінного взуття тапочки можна взяти в адміністратора.'
    },
    {
      text: 'Загальна кількість людей на зйомці не більш як п\'ять, включаючи фотографа. Понад 5 осіб стягується доплата у розмірі 100 грн. за 1 особу за 1 годину. Якщо організатор зйомки влаштовує будь-який захід, на якому буде присутнім більше п\'яти осіб одночасно, він зобов\'язаний попередити адміністрацію студії заздалегідь..'
    },
    {
      text: 'У залах заборонено куріння будь-яких тютюнових виробів (включаючи iqos, glo та інші) та розпивання алкогольних напоїв. Недотримання правила штрафується у розмірі 500 грн.\n'
    },
    {
      text: 'Зняття софтбоксів із освітлювального обладнання без присутності адміністратора КАТЕГОРИЧНО ЗАБОРОНЕНО. Під час роботи зі студійними освітлювачами будьте обережні!\n' +
        'Заборонено приклеювати що-небудь на стіни, вікна та дзеркало скотчем або будь-яким іншим способом, можливе забруднення їхньої поверхні. Також заборонено запалювати свічки, які знаходяться в студії. Якщо ви хочете щось запалювати, кличте адміністратора.\n' +
        '\n' +
        'Вартість запалених свічок 200 грн. Використання бенгальських свічок заборонено у залах із дерев\'яним паркетом.'
    },
    {
      text: 'Адміністратор має право перебувати у студії (у спеціально відведеному місці, не заважаючи і не бентежить орендарів), щоб перевірити її стан, цілісність обладнання та декорацій.\n' +
        'Попередній показ студії здійснюється за попереднім дзвінком, суворо за умови, що зал вільний, або у перерві між орендами.'
    },
    {
      text: 'Якщо зйомка планується проводити за участю тварин, про це потрібно попередити адміністратора заздалегідь. Доплата за одну тварину 100грн./час. У разі псування майна студії відповідальність лягає на орендаря. Також адміністратор має право взяти плату за прибирання залу.'
    },
    {
      text: 'На одну залу передбачено використання до 2 джерел світла. Кожен наступне оплачується 250 грн/год.'
    }
  ];

  constructor() { }

  ngOnInit() {

  }

}
